import { createFeatureSelector, createSelector } from '@ngrx/store'
import { GovernmentBusinessState } from '../state/government-business.state'

const getGovernmentBusinessState = createFeatureSelector<GovernmentBusinessState>('governmentBusiness')

export const getGovernmentBusinessDashboardInfo = createSelector(getGovernmentBusinessState, state => state?.dashboard)

export const getGovernmentBusinessDetails = () =>
  createSelector(getGovernmentBusinessState, state => {
    return state?.details
  })

export const governmentBusinessSummaryDetail = () =>
  createSelector(getGovernmentBusinessState, state => {
    return state?.summary
  })
